/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { bool, string, object } from 'prop-types';

import Error from '@material-ui/icons/Error';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { sanitizeContent } from '../../../../../../../lib/sanitize';

const styles = (theme) => ({
    errorMsg: {
        fontSize: '1em',
        color: theme.palette.error.main,
        backgroundColor: '#FFF',
        padding: '10px',
        wordWrap: 'break-word',
        '& a': {
            color: theme.palette.error.main,
            textDecoration: 'underline',
        },
    },
    errorSmallFont: {
        fontSize: '0.875em !important',
    },
    addShadow: {
        boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
    },
    icon: {
        fontSize: '1.4rem',
        marginTop: '-5px',
        marginRight: '4px',
        marginBottom: '-5px',
        display: 'inline',
    },
    iconPromotion: {
        margin: '0 4px 0 0',
        float: 'left',
        fontSize: '1em',
    },
    message: {
        display: 'inline',
    },
    extCart: {
        backgroundColor: '#FAFAFA',
        textAlign: 'center',
        margin: '0 0 10px',
    },
});

const ErrorMessage = ({
    align,
    classes,
    classExtCart,
    error,
    errorSmallFont,
    isOnePageCheckout,
    noShadow,
    noErrorIcon,
}) => {
    if (!error) { return null; }

    let classesErrorMessage = '';
    classesErrorMessage = (!noShadow) ? classes.addShadow : '';
    classesErrorMessage = (classExtCart) ? classes.extCart : classesErrorMessage;
    classesErrorMessage = (errorSmallFont) ? `${classesErrorMessage} ${classes.errorSmallFont}`.trim() : classesErrorMessage;

    const formatStringValue = (str) => {
        if (str && str.length > 0) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
        return '';
    };

    return (
        <Typography
            align={align}
            variant="body2"
            className={`errorMessage ${classes.errorMsg} ${classesErrorMessage}`}
        >
            { !noErrorIcon && <Error className={classes.icon} color="error" /> }
            {
                error === 'Product Error' && isOnePageCheckout
                    ? (
                        <span className={classes.message}>
                            <span>Some items need your review. Please resolve any errors before placing your order.</span>
                        </span>
                    )
                    : <span className={classes.message}> { sanitizeContent(formatStringValue(error)) } </span>
            }

        </Typography>
    );
};

ErrorMessage.propTypes = {
    align: string,
    classes: object.isRequired,
    classExtCart: bool,
    error: string.isRequired,
    errorSmallFont: bool,
    isOnePageCheckout: bool,
    noErrorIcon: bool,
    noShadow: bool,
};

ErrorMessage.defaultProps = {
    align: 'left',
    classExtCart: false,
    errorSmallFont: false,
    isOnePageCheckout: false,
    noShadow: false,
    noErrorIcon: false,
};

export default withStyles(styles)(ErrorMessage);
